import { TargetSchemaItem } from '../authentication-method-policy-utlity';
import { AuthenticationMethodsVoiceSchema, VoiceAuthenticationMethodConfigurationForm } from './model';

export function updateAuthenticationMethodsVoiceSchema(
    form: VoiceAuthenticationMethodConfigurationForm,
): AuthenticationMethodsVoiceSchema {
    // If state is disabled, only return state property
    if (form.state === 'disabled') {
        return {
            type: 'object',
            properties: {
                state: { type: 'string', const: form.state },
            },
        };
    }

    const includedTargetsOneOfItems: TargetSchemaItem[] = form.includeTargets.includedGroups.map((group) => ({
        properties: {
            id: { type: 'string', const: group.id },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    const excludeTargetsOneOfItems: TargetSchemaItem[] = form.excludeTargets.map((group) => ({
        properties: {
            id: { type: 'string', const: group },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    return {
        type: 'object',
        properties: {
            state: { type: 'string', const: form.state },
            isOfficePhoneAllowed: { type: 'boolean', const: form.isOfficePhoneAllowed },
            includeTargets:
                includedTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: includedTargetsOneOfItems,
                          },
                          minItems: includedTargetsOneOfItems.length,
                          maxItems: includedTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },

            excludeTargets:
                excludeTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: excludeTargetsOneOfItems,
                          },
                          minItems: excludeTargetsOneOfItems.length,
                          maxItems: excludeTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },
        },
    };
}
